
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import html2canvas from "html2canvas";
import request from "@/lib/request/request";
import gateway from "@/lib/request/gateway";
import ModalHeader from "@/components/modal-header.vue";
import QrCodeDiy from "@/components/QrCodeDiy.vue";
import AddMoreCandidateModal from "./add-candidates.vue";
import AddOneCandidateModal from "./add-candidate.vue";
import {
  ExamList,
  ExamItem,
  ExamSmallItem
} from "@/lib/model/exambuilder/exam-component/exam-list";
import { ExamComponent } from "@/lib/model/exambuilder/exam-component/exam";
import {
  CandidateCreateMore,
  CandidateCreateOne
} from "@/lib/model/exambuilder/exam-component/candidate";

class CodeText {
  mainText = "欢迎使用AI面试"; //主标题
  subText = "快速 · 轻松 · 便捷"; //副标题
  tagShow = false;
  tagText = ""; //标签文字
  mainColor = "#5f45f2";
  subColor = "#181f71";
  logoShow = false;
  logoUrl = ""; //公司logo图片
  coderImgUrl = ""; //考试链接url
}

enum TabItem {
  ConnectCode, // 面试链接码（1 开头的码）
  ConnectCodeForInvite // 定向邀请二维码（3 开头的码）
}

// 面试链接
@Component({
  components: {
    AddOneCandidateModal,
    AddMoreCandidateModal,
    ModalHeader,
    QrCodeDiy
  }
})
export default class ExamLink extends Vue {
  @Prop({ default: () => false }) fromList!: boolean; // 是否从列表页跳转
  @Prop({ default: () => new ExamItem() }) examListItem!: ExamItem; // 面试列表项model
  @Prop({ default: () => [] }) private examAll!: ExamSmallItem[];
  @Prop({ default: () => new ExamComponent() }) examComponent!: ExamComponent; //面试model

  TabItem = TabItem;

  @Emit("on-success-status")
  onSuccessStatus() {
    return true;
  }

  get examId() {
    if (this.examListItem.examId) {
      return this.examListItem.examId;
    } else {
      return this.examComponent.metaInfo.examId;
    }
  }

  get examName() {
    if (this.examListItem.examId) {
      return this.examListItem.name;
    } else {
      return this.examComponent.examInfo.name;
    }
  }

  get connectCode() {
    if (this.examListItem.examId) {
      return this.examListItem.connectCode;
    } else {
      return this.examComponent.metaInfo.connectCode;
    }
  }

  // 定向邀请二维码（3 开头的码）
  get connectCodeForInvite() {
    if (this.examListItem.examId) {
      return this.examListItem.connectCodeForInvite;
    } else {
      return this.examComponent.metaInfo.connectCodeForInvite;
    }
  }

  // 能否公开邀请
  get canOpenJoin() {
    if (this.fromList) {
      return this.examListItem.canOpenJoin === 1;
    } else {
      return (
        this.examComponent.examVersionInfo.timeLimitConfig.canOpenJoin === 1
      );
    }
  }

  show = false;
  hoverJob = new CodeText();
  codeText = new CodeText();
  codeTextForInvite = new CodeText();
  activeTab = this.canOpenJoin
    ? TabItem.ConnectCode
    : TabItem.ConnectCodeForInvite; // 当前选择的 tab
  editing = false;
  imgFile: any = null;
  submitting = false;

  async saveCodeText() {
    //处理空
    if (!this.codeText.mainText) {
      this.$message.warning("请输入主标题");
      return;
    }

    if (!this.codeText.subText) {
      this.$message.warning("请输入副标题");
      return;
    }

    if (!this.codeText.mainColor) {
      this.$message.warning("请选择主题色");
      return;
    }

    if (!this.codeText.subColor) {
      this.$message.warning("请选择辅助色");
      return;
    }

    if (this.codeText.tagShow && !this.codeText.tagText) {
      this.$message.warning("请输入标签文字");
      return;
    }

    if (this.codeText.logoShow && !this.codeText.logoUrl) {
      this.$message.warning("请上传logo");
      return;
    }

    this.submitting = true;

    if (!this.codeText.logoShow) {
      this.codeText.logoUrl = "";
    } else if (this.imgFile) {
      // 上传图片到oss
      await gateway
        .anonymousGetPostPolicy(this.imgFile.name)
        .then(async (postRes: any) => {
          if (!postRes) return;

          const tempUrl = `${postRes.cdn}/${encodeURIComponent(postRes.dir)}`;
          await gateway
            .upload(postRes, this.imgFile)
            .finally(() => (this.codeText.logoUrl = tempUrl));
        })
        .catch((err: any) => {
          this.$message.error(err.msg);
          this.submitting = false;
          return;
        });
    }

    await request
      .postInterviewApi("hr/exam/qrConfig/save", {
        examId: this.examId,
        qrConfig: this.codeText
      })
      .then(() => {
        this.$message.success("保存成功");
        this.submitting = false;
        this.cancelEdit();
      })
      .catch((err: any) => {
        this.$message.error(err.msg);
        this.submitting = false;
      });
  }

  setActiveTab(tab: TabItem) {
    if (this.canOpenJoin) {
      this.activeTab = tab;
    }
  }

  // 获取二维码配置信息
  getCodeText() {
    return ExamList.wsaCode(this.connectCode)
      .then((res: any) => {
        if (res.data.find) {
          this.codeText = JSON.parse(JSON.stringify(res.data.qrConfig));
          this.codeTextForInvite = JSON.parse(
            JSON.stringify(res.data.qrConfig)
          );
        } else {
          this.codeText = new CodeText();
          this.codeTextForInvite = new CodeText();
        }
      })
      .finally(() => {
        const url = `${process.env.VUE_APP_AI_INTERVIEW_HOST}/code?c=${this.connectCode}`;
        this.codeText.coderImgUrl = url;
        console.log("🚀 ~ ExamLink ~ .finally ~ this.codeText:", this.codeText);
        const urlForInvite = `${process.env.VUE_APP_AI_INTERVIEW_HOST}/code?c=${this.connectCodeForInvite}`;
        this.codeTextForInvite.coderImgUrl = urlForInvite;
        console.log(
          "🚀 ~ ExamLink ~ .finally ~ this.codeTextForInvite:",
          this.codeTextForInvite
        );
        console.log(
          "🚀 ~ ExamLink ~ .finally ~ this.activeTab:",
          this.activeTab
        );
      });
  }

  edit() {
    this.editing = true;
  }

  cancelEdit() {
    this.imgFile = null;
    this.getCodeText().then(() => (this.editing = false));
  }

  openFile(e: any) {
    const file = e?.target?.files?.[0];
    console.log(file);
    if (!file) {
      this.$message.warning("请选择图片");
      return;
    }
    if (!file.type.includes("image")) {
      this.$message.warning("请选择常用的图片格式");
      return;
    }
    if (file.size > 1024 * 1024 * 2) {
      this.$message.warning("图片大小不能超过2M");
      return;
    }

    this.imgFile = file;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.codeText.logoUrl = reader.result as string;
    };
  }

  async created() {
    await this.getCodeText();
    this.show = true;
  }

  @Emit("on-add-cancel")
  close() {
    return false;
  }

  copyLinkJob(url: string) {
    //创建input标签
    const input = document.createElement("input");
    //将input的值设置为需要复制的内容
    input.value = url;
    //添加input标签
    document.body.appendChild(input);
    //选中input标签
    input.select();
    //执行复制
    document.execCommand("copy");
    //移除input标签
    document.body.removeChild(input);
    this.$message.success("复制成功");
  }

  downloadBarcode(fileName = "AI面试二维码", coderAnchor = "coderAnchor") {
    this.$message.success("二维码下载中");
    const anchor = this.$refs[coderAnchor] as HTMLElement;
    // 复制一个anchor元素加入到document
    const copyAnchor = anchor.cloneNode(true) as HTMLElement;
    copyAnchor.style.position = "fixed";
    copyAnchor.style.top = "-10000px";
    copyAnchor.style.left = "-10000px";
    document.body.appendChild(copyAnchor);
    html2canvas(copyAnchor, {
      useCORS: true,
      allowTaint: true,
      scale: 3,
      scrollX: 0,
      scrollY: 0
    }).then((canvas: HTMLCanvasElement) => {
      const dataURL = canvas.toDataURL("image/jpeg");
      const a = document.getElementById("download") as HTMLAnchorElement;
      a.href = dataURL;
      a.download = fileName + ".jpeg";
      a.click();
      // 将copyAnchor移除
      document.body.removeChild(copyAnchor);
    });
  }

  // 添加候选人
  isShowAddOne = false;
  isShowAddMore = false;

  get paperId() {
    // 添加候选人弹窗用面试id
    return this.examId;
  }

  candidateCreateOne = new CandidateCreateOne();
  candidateCreateMore = new CandidateCreateMore();

  showAdd(key: string) {
    if (key === "one") {
      this.candidateCreateOne.examId = this.examId;
      this.isShowAddMore = false;
      this.isShowAddOne = true;
    } else if (key === "more") {
      this.candidateCreateMore.examId = this.examId;
      this.isShowAddOne = false;
      this.isShowAddMore = true;
    }
  }
}
